export default {
  isShown: false,
  content: `
    We are pleased to announce the publication of the PME-NA 40 conference proceedings! Download the proceedings&nbsp;
    <a target="_blank" rel="noopener noreferrer" href="https://s3.us-east-2.amazonaws.com/pmena2018/documents/public/PMENA+2018+Proceedings.pdf">
      <strong>here</strong>
    </a>.
  `
}


// WEBPACK FOOTER //
// ./src/data/snackbar.js